import api from './api';

export type FeedbackType = 'bug' | 'feature' | 'other';

export interface FeedbackCreate {
  type: FeedbackType;
  title: string;
  description: string;
}

export interface Feedback {
  id: string;
  user_email: string;
  user_name: string;
  wedding_id: string;
  type: FeedbackType;
  title: string;
  description: string;
  created_at: string;
}

export const createFeedback = (data: FeedbackCreate) =>
  api.post<Feedback>('/feedback', data);

export const getAllFeedback = () =>
  api.get<Feedback[]>('/feedback');

export const deleteFeedback = (id: string) =>
  api.delete(`/feedback/${id}`);
